// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + {"327":"stream","372":"merch","382":"video-detail","463":"videos","496":"campaigns","623":"affiliates"}[chunkId] + "." + {"327":"1eb877ca","372":"5cd89ab0","382":"5bcdd6a8","463":"041d3939","496":"0e5899d5","623":"70bc460e"}[chunkId] + ".js";
};